/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  getIsBossEnabled,
  getIsBopisEnabled,
  getIsBossClearanceProductEnabled,
  getIsBopisClearanceProductEnabled,
  getIsRadialInventoryEnabled,
  getIsInternationalShipping,
  getIsDynamicBadgeEnabled,
  getIsOffersDisplayEnabled,
  getIsHideMeatBallMenuAbTest,
  getIsShowEditCTAAbTest,
  getIsSFLEnabledApp,
  getIsPersistPointsApiEnabled,
  getIsVMPBossEnabled,
  getIsCrossBrandMerchandisingEnabled,
  getExtendedPreOrderValue,
  getIsHideOriginalPriceAndMarchantTagEnabled,
  getIsHardcodeSizeMapEnabled,
  getHardcodeSizeMapConfig,
  getBossUnavailableSwitch,
  getNonEligibleForCouponsEnabled,
  getIsSocialProofViaEngineApiEnabled,
  getIsSiteBusterAbTestEnabled,
  getPromoKeyConfig,
  getDesktopProductTileCleanUpDisabled,
  getDisplayAvailableOffersAbTest,
  getIsBopisPromotionDiscountEnabled,
  getStoreHoursThreshold,
  getIsFullDateDisplayEnabled,
  getIsDisplayPickupTimeEnabled,
  getIsShowDeleteIconInBag,
  getMobileWebProductTileEnhancement,
  getShowBopisTileBasedOnStoreSpecials,
  getIsAppendUPCInPDPURLEnabled,
  getIsItemLevelOnHoldMsgEnabled,
  getRestrictedShippingStatesEnabled,
  getStateNameMap,
  getIsBrandExclusionMessageEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import CHECKOUT_ACTIONS from '@tcp/core/src/components/features/CnC/Checkout/container/Checkout.action';
import {
  getBossStatus,
  getRemoveItemInProgress,
} from '@tcp/core/src/components/features/CnC/SinglePageCheckout/container/SinglePageCheckout.selector';
import {
  getIsMiniBagOpen,
  getBossState,
  getBossCity,
  getBopisState,
  getBopisCity,
  getCartLoadingState,
  getOrderShipments,
  getTileLoadingState,
  getIsCartItemsUpdating,
  getSocialProofCartMessage,
} from '@tcp/core/src/components/features/CnC/CartItemTile/container/CartItemTile.selectors';
import { getPromotionsData } from '@tcp/core/src/components/common/organisms/Promotions/container/Promotions.selectors';
import NavigateXHRSelector from '@tcp/core/src/components/features/account/NavigateXHR/container/NavigateXHR.selectors';
import { setClickAnalyticsData } from '@tcp/core/src/analytics/actions';
import { getCurrencyAttributesAsArray } from '@tcp/core/src/reduxStore/selectors/currency.selectors';
import isEqual from 'lodash/isEqual';
import BAG_PAGE_ACTIONS from '../../BagPage/container/BagPage.actions';
import BAGPAGE_SELECTORS from '../../BagPage/container/BagPage.selectors';
import {
  removeCartItem,
  updateCartItem,
  getProductSKUInfo,
  openPickupModalWithValuesFromBag,
  clearToggleCartItemError,
  clearToggleBossBopisCartItemError,
  setBackPackAloneError,
  setBackPackOOSError,
  backpackSFLCall,
} from './CartItemTile.actions';
import {
  getEditableProductInfo,
  getCartToggleError,
  getCartBossBopisToggleError,
  isBrierleyWorking,
  getEditableProductMultiPackInfo,
  getSflBackPackCall,
} from './CartItemTile.selectors';
import {
  getSaveForLaterSwitch,
  getSflMaxCount,
} from '../../SaveForLater/container/SaveForLater.selectors';
import {
  getDefaultStoreData,
  getPersonalDataState,
  getUserLoggedInState,
} from '../../../account/User/container/User.selectors';
import {
  openQuickViewWithValues,
  updateAppTypeWithParams,
} from '../../../../common/organisms/QuickViewModal/container/QuickViewModal.actions';
import CARTPAGE_CONSTANTS from '../CartItemTile.constants';
import CONSTANTS from '../../Checkout/Checkout.constants';
import { addItemsToWishlist } from '../../../browse/Favorites/container/Favorites.actions';
import { isMobileWeb } from '../../../../../utils';
import { getPickupStoreModalRedsign } from '../../../../common/organisms/PickupStoreModal/container/PickUpStoreModal.selectors';
import {
  updateDeliveryMethodSelection,
  setCartProductData,
} from '../../../browse/ProductDetail/container/ProductDetail.actions';
import { getBreadCrumbs } from '../../../browse/ProductDetail/container/ProductDetail.selectors';
import { moveItemsToBossUnavailableList } from '../molecules/BossUnavailableTile/container/BossUnavailable.actions';
import { getOrderEddDates } from '../../common/molecules/EddComponent/container/EddComponent.selectors';
import {
  getDefaultBopisPromotionDiscountValue,
  getOfferTypeBasedPromotion,
} from '../../../../common/molecules/PickupBopisPromotionBanner/container/BopisPromotionBanner.selector';
import {
  getLastAppliedCoupon,
  getLastAppliedCouponData,
} from '../../common/organism/CouponAndPromos/container/Coupon.selectors';
import {
  getCouponTermsAndConditions,
  setOpenCouponDetailModalActn,
} from '../../common/organism/CouponAndPromos/container/Coupon.actions';

const CartItemTile = dynamic(() =>
  import(
    // eslint-disable-next-line extra-rules/no-commented-out-code
    /* webpackChunkName: "CartItemTile" */ '../molecules/CartItemTile/views/CartItemTile.view'
  )
);

const CartItemNewTile = dynamic(() =>
  import(
    // eslint-disable-next-line extra-rules/no-commented-out-code
    /* webpackChunkName: "CartItemNewTile" */ '../molecules/CartItemTile/views'
  )
);

/* eslint-disable no-shadow */
export class CartItemTileContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      generalProductId: '',
      productDataforDelete: null,
      showLoginModal: false,
    };
    this.quantityListHolder = [];
  }

  getQuantityList = () => {
    const { isShowDeleteIconInBag } = this.props;
    const quantityArray = isShowDeleteIconInBag ? new Array(16).fill(1) : new Array(15).fill(1);
    const quantityArrayTemp = quantityArray.map((val, index) => {
      let quantity = isShowDeleteIconInBag ? index : index + 1;
      if (isShowDeleteIconInBag && index === 0) {
        quantity = '0';
      }
      return {
        displayName: quantity,
        id: quantity,
      };
    });
    if (!isEqual(this.quantityListHolder, quantityArrayTemp)) {
      this.quantityListHolder = quantityArrayTemp;
    }
    return this.quantityListHolder;
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    const { isLoggedIn, onAddItemToFavorites, startSflItemDelete } = nextProps;
    const { generalProductId, productDataforDelete } = prevState;

    if (isLoggedIn && generalProductId !== '') {
      onAddItemToFavorites({
        colorProductId: generalProductId,
      });
      startSflItemDelete({ ...productDataforDelete });
      return { generalProductId: '' };
    }
    return null;
  }

  handleAddToWishlist = () => {
    const { productDetail, onAddItemToFavorites, startSflItemDelete, isLoggedIn } = this.props;
    const {
      itemInfo: { itemId },
      productInfo: { generalProductId },
    } = productDetail;
    const generalProductIdState = generalProductId;
    const catEntryId = itemId;
    const payloadData = { catEntryId };
    onAddItemToFavorites({ colorProductId: generalProductId });
    if (isLoggedIn) {
      startSflItemDelete({ ...payloadData });
    } else {
      this.setState({
        generalProductId: generalProductIdState,
        productDataforDelete: payloadData,
        showLoginModal: true,
      });
    }
  };

  toggleLoginModal = () => {
    this.setState((state) => ({
      showLoginModal: !state.showLoginModal,
    }));
  };

  updateSocialProofDataInProductDetail = (productDetail, socialProofCartData) => {
    const productId = productDetail?.productInfo?.productPartNumber;

    const matchingSocialProofItem = socialProofCartData?.find(
      (item) => item?.productId === productId
    );

    if (matchingSocialProofItem) {
      const updatedProductDetail = { ...productDetail };

      updatedProductDetail.socialProofData = {
        productId,
        proofType: matchingSocialProofItem?.proofType,
        component: matchingSocialProofItem?.component,
      };

      return updatedProductDetail;
    }

    return productDetail;
  };

  couponDetailClick = (coupon) => {
    const { fetchCouponTermsAndConditions, setOpenCouponDetailModal } = this.props;

    const payload = { ...coupon };
    if (!coupon.legalText && coupon.promotionId) fetchCouponTermsAndConditions(payload);
    setOpenCouponDetailModal(true);
  };

  render() {
    const {
      productDetail,
      removeCartItem,
      updateCartItem,
      isMiniBagOpen,
      getProductSKUInfo,
      editableProductInfo,
      editableProductMultiPackInfo,
      pageView,
      className,
      isEditAllowed,
      toggleEditAllowance,
      isDeleteAnimationEnabled,
      inheritedStyles,
      isPlcc,
      itemIndex,
      openedTile,
      setSelectedProductTile,
      setSwipedElement,
      swipedElement,
      isShowSaveForLater,
      sflMaxCount,
      isGenricGuest,
      addItemToSflList,
      setCartItemsSflError,
      sflItemsCount,
      isBagPageSflSection,
      startSflItemDelete,
      startSflDataMoveToBag,
      onQuickViewOpenClick,
      isBossEnabledTCP,
      isBossEnabledGYM,
      isBopisEnabledTCP,
      isBopisEnabledGYM,
      isBossClearanceProductEnabled,
      isBopisClearanceProductEnabled,
      isRadialInventoryEnabled,
      onPickUpOpenClick,
      orderId,
      setShipToHome,
      toggleError,
      toggleBossBopisError,
      clearToggleError,
      pickupStoresInCart,
      autoSwitchPickupItemInCart,
      navigation,
      updateAppTypeHandler,
      disableProductRedirect,
      setClickAnalyticsData,
      closeMiniBag,
      isLoggedIn,
      cartOrderItems,
      isBrierleyWorking,
      isInternationalShipping,
      cookieToken,
      isMultipackProduct,
      isMiniBag,
      isDynamicBadgeEnabled,
      spcBag,
      newBag,
      isCartLoading,
      isTileLoading,
      newMiniBag,
      isLowInventoryBannerEnabled,
      isLowInventoryBannerEnabledForOldDesign,
      bossState,
      bossCity,
      bopisState,
      bopisCity,
      hideCartItemBoxButtons,
      isCartQuantityUpdating,
      isHideMeatBallAbTest,
      isShowEditCTAAbTest,
      isPickupStoreModalRedisgn,
      orderEddDates,
      shippingMethodSelected,
      userDefaultStore,
      updateStoreItem,
      LoyaltyPoints,
      isOffersDisplayEnabled,
      shipments,
      showToggleLinkProductTile,
      pickUpTileEnabled,
      isBossCart,
      isNonBossCart,
      orderPriceAdjustments,
      updateDeliveryMethodIndex,
      isAppSFLEnabled,
      orderAccessorieItems,
      isLoyaltyPointsEnabled,
      setBackPackAloneErrorRedux,
      setBackPackOOSErrorRedux,
      isBossEnabled,
      sflItems,
      buttonLoading,
      isBopisEnabled,
      clearCheckoutServerError,
      setBackPackDeletedErrorAction,
      isVMPBOSSEnabled,
      isBossEnabledSNJ,
      isBopisEnabledSNJ,
      isBossEnabledPJP,
      isBopisEnabledPJP,
      backpackSFLCallAction,
      sflBackPackCall,
      isCrossBrandMerchandisingEnabled,
      isCartItemsUpdating,
      extendedOrderThreshold,
      isRemoveItemInProgress,
      isHardPriceMarkdownEnabled,
      isHardcodeSizeMapEnabled,
      hardcodeSizeMapConfig,
      moveItemsToBossUnavailableListAction,
      bossUnavailableSwitch,
      lastListItem,
      isBossUnavailableValue,
      getBossUnavailableItems,
      totalItems,
      socialProofCartData,
      isNonEligibleForCouponsEnabled,
      isSocialProofViaEngineApiEnabledApp,
      isSiteBusterAbTestEnabled,
      promoKey,
      isDesktopProductTileCleanUpDisabled,
      orderEddDatesValues,
      displayAvailableOffersAbTest,
      isBopisPromoDiscountBannerEnabled,
      offerTypeBasedPromotion,
      defaultBopisPromotionDiscountValue,
      allPromotionsData,
      storeHoursThreshold,
      isDisplayPickupTimeEnabled,
      isFullDateDisplayEnabled,
      userStore,
      isShowDeleteIconInBag,
      isMobileWebTileEnhancementEnabled,
      saveProductDataForPdp,
      showBopisTileBasedOnStoreSpecials,
      isAppendUPCInPDPURLEnabled,
      cartProductsWithPriceDrop,
      sflProductsWithPriceDrop,
      isPriceDropNotificationEnabled,
      lastAppliedCoupon,
      lastAppliedCouponData,
      isItemLevelOnHoldMsgEnabled,
      isRestrictedShippingStatesEnabled,
      stateNameMap,
      isBrandExclusionMessageEnabled,
    } = this.props;

    const updatedProductDetail = this.updateSocialProofDataInProductDetail(
      productDetail,
      socialProofCartData
    );

    const { showLoginModal } = this.state;
    const { breadCrumbs } = this.props;
    const { currencyExchange } = this.props;
    let animationTimeOut = 0;
    if (isMobileWeb) {
      animationTimeOut = isMobileWeb() && isDeleteAnimationEnabled ? 1100 : 0;
    }
    return newBag && !isMiniBag ? (
      <CartItemNewTile
        animationTimeOut={animationTimeOut}
        productDetail={productDetail}
        removeCartItem={removeCartItem}
        updateCartItem={updateCartItem}
        isMiniBagOpen={isMiniBagOpen}
        getProductSKUInfo={getProductSKUInfo}
        editableProductInfo={editableProductInfo}
        editableProductMultiPackInfo={editableProductMultiPackInfo}
        pageView={pageView}
        className={className}
        toggleEditAllowance={toggleEditAllowance}
        isEditAllowed={isEditAllowed}
        inheritedStyles={inheritedStyles}
        isPlcc={isPlcc}
        itemIndex={itemIndex}
        openedTile={openedTile}
        setSelectedProductTile={setSelectedProductTile}
        setSwipedElement={setSwipedElement}
        swipedElement={swipedElement}
        isShowSaveForLater={isShowSaveForLater}
        sflMaxCount={sflMaxCount}
        isGenricGuest={isGenricGuest}
        addItemToSflList={addItemToSflList}
        setCartItemsSflError={setCartItemsSflError}
        sflItemsCount={sflItemsCount}
        isBagPageSflSection={isBagPageSflSection}
        startSflItemDelete={startSflItemDelete}
        startSflDataMoveToBag={startSflDataMoveToBag}
        onQuickViewOpenClick={onQuickViewOpenClick}
        isBossEnabledTCP={isBossEnabledTCP}
        isBossEnabledGYM={isBossEnabledGYM}
        isBopisEnabledTCP={isBopisEnabledTCP}
        isBopisEnabledGYM={isBopisEnabledGYM}
        isBossEnabledSNJ={isBossEnabledSNJ}
        isBopisEnabledSNJ={isBopisEnabledSNJ}
        isBossEnabledPJP={isBossEnabledPJP}
        isBopisEnabledPJP={isBopisEnabledPJP}
        isBossClearanceProductEnabled={isBossClearanceProductEnabled}
        isBopisClearanceProductEnabled={isBopisClearanceProductEnabled}
        isRadialInventoryEnabled={isRadialInventoryEnabled}
        onPickUpOpenClick={onPickUpOpenClick}
        orderId={orderId}
        setShipToHome={setShipToHome}
        toggleError={toggleError}
        toggleBossBopisError={toggleBossBopisError}
        clearToggleError={clearToggleError}
        currencyExchange={currencyExchange}
        pickupStoresInCart={pickupStoresInCart}
        autoSwitchPickupItemInCart={autoSwitchPickupItemInCart}
        navigation={navigation}
        updateAppTypeHandler={updateAppTypeHandler}
        disableProductRedirect={disableProductRedirect}
        setClickAnalyticsData={setClickAnalyticsData}
        closeMiniBag={closeMiniBag}
        handleAddToWishlist={this.handleAddToWishlist}
        isLoggedIn={isLoggedIn}
        showLoginModal={showLoginModal}
        toggleLoginModal={this.toggleLoginModal}
        cartOrderItems={cartOrderItems}
        isInternationalShipping={isInternationalShipping}
        cookieToken={cookieToken}
        isMiniBag={isMiniBag}
        isMultipackProduct={isMultipackProduct}
        isBrierleyWorking={isBrierleyWorking}
        isDynamicBadgeEnabled={isDynamicBadgeEnabled}
        breadCrumbs={breadCrumbs}
        newBag={newBag}
        isLowInventoryBannerEnabled={isLowInventoryBannerEnabled}
        isCartLoading={isCartLoading}
        isTileLoading={isTileLoading}
        bossState={bossState}
        bossCity={bossCity}
        bopisState={bopisState}
        bopisCity={bopisCity}
        quantityList={this.getQuantityList()}
        hideCartItemBoxButtons={hideCartItemBoxButtons}
        isPickupStoreModalRedisgn={isPickupStoreModalRedisgn}
        isCartQuantityUpdating={isCartQuantityUpdating}
        shippingMethodSelected={shippingMethodSelected}
        orderEddDates={orderEddDates}
        userDefaultStore={userDefaultStore}
        updateStoreItem={updateStoreItem}
        LoyaltyPoints={LoyaltyPoints}
        isOffersDisplayEnabled={isOffersDisplayEnabled}
        isHideMeatBallAbTest={isHideMeatBallAbTest}
        isShowEditCTAAbTest={isShowEditCTAAbTest}
        newMiniBag={newMiniBag}
        shipments={shipments}
        showToggleLinkProductTile={showToggleLinkProductTile}
        pickUpTileEnabled={pickUpTileEnabled}
        isBossCart={isBossCart}
        isNonBossCart={isNonBossCart}
        orderPriceAdjustments={orderPriceAdjustments}
        updateDeliveryMethodIndex={updateDeliveryMethodIndex}
        isAppSFLEnabled={isAppSFLEnabled}
        orderAccessorieItems={orderAccessorieItems}
        isLoyaltyPointsEnabled={isLoyaltyPointsEnabled}
        setBackPackAloneErrorRedux={setBackPackAloneErrorRedux}
        setBackPackOOSErrorRedux={setBackPackOOSErrorRedux}
        isBossEnabled={isBossEnabled}
        sflItems={sflItems}
        buttonLoading={buttonLoading}
        isBopisEnabled={isBopisEnabled}
        clearCheckoutServerError={clearCheckoutServerError}
        setBackPackDeletedErrorAction={setBackPackDeletedErrorAction}
        isVMPBOSSEnabled={isVMPBOSSEnabled}
        backpackSFLCallAction={backpackSFLCallAction}
        sflBackPackCall={sflBackPackCall}
        isCrossBrandMerchandisingEnabled={isCrossBrandMerchandisingEnabled}
        isCartItemsUpdating={isCartItemsUpdating}
        extendedOrderThreshold={extendedOrderThreshold}
        isRemoveItemInProgress={isRemoveItemInProgress}
        isDeleteAnimationEnabled={isDeleteAnimationEnabled}
        isHardPriceMarkdownEnabled={isHardPriceMarkdownEnabled}
        isHardcodeSizeMapEnabled={isHardcodeSizeMapEnabled}
        hardcodeSizeMapConfig={hardcodeSizeMapConfig}
        isMobileWebProductTile={isMobileWeb()}
        moveItemsToBossUnavailableListAction={moveItemsToBossUnavailableListAction}
        bossUnavailableSwitch={bossUnavailableSwitch}
        lastListItem={lastListItem}
        isBossUnavailableValue={isBossUnavailableValue}
        getBossUnavailableItems={getBossUnavailableItems}
        totalItems={totalItems}
        updatedProductDetail={updatedProductDetail}
        isNonEligibleForCouponsEnabled={isNonEligibleForCouponsEnabled}
        isSocialProofViaEngineApiEnabledApp={isSocialProofViaEngineApiEnabledApp}
        isSiteBusterAbTestEnabled={isSiteBusterAbTestEnabled}
        promoKey={promoKey}
        isDesktopProductTileCleanUpDisabled={isDesktopProductTileCleanUpDisabled}
        orderEddDatesValues={orderEddDatesValues}
        displayAvailableOffersAbTest={displayAvailableOffersAbTest}
        isBopisPromoDiscountBannerEnabled={isBopisPromoDiscountBannerEnabled}
        offerTypeBasedPromotion={offerTypeBasedPromotion}
        defaultBopisPromotionDiscountValue={defaultBopisPromotionDiscountValue}
        allPromotionsData={allPromotionsData}
        storeHoursThreshold={storeHoursThreshold}
        isDisplayPickupTimeEnabled={isDisplayPickupTimeEnabled}
        isFullDateDisplayEnabled={isFullDateDisplayEnabled}
        userStore={userStore}
        isShowDeleteIconInBag={isShowDeleteIconInBag}
        isMobileWebTileEnhancementEnabled={isMobileWebTileEnhancementEnabled}
        saveProductDataForPdp={saveProductDataForPdp}
        showBopisTileBasedOnStoreSpecials={showBopisTileBasedOnStoreSpecials}
        isAppendUPCInPDPURLEnabled={isAppendUPCInPDPURLEnabled}
        sflProductsWithPriceDrop={sflProductsWithPriceDrop}
        cartProductsWithPriceDrop={cartProductsWithPriceDrop}
        isPriceDropNotificationEnabled={isPriceDropNotificationEnabled}
        lastAppliedCoupon={lastAppliedCoupon}
        couponDetailClick={this.couponDetailClick}
        lastAppliedCouponData={lastAppliedCouponData}
        isItemLevelOnHoldMsgEnabled={isItemLevelOnHoldMsgEnabled}
        isRestrictedShippingStatesEnabled={isRestrictedShippingStatesEnabled}
        stateNameMap={stateNameMap}
        isBrandExclusionMessageEnabled={isBrandExclusionMessageEnabled}
      />
    ) : (
      <CartItemTile
        productDetail={productDetail}
        removeCartItem={removeCartItem}
        updateCartItem={updateCartItem}
        isMiniBagOpen={isMiniBagOpen}
        getProductSKUInfo={getProductSKUInfo}
        editableProductInfo={editableProductInfo}
        editableProductMultiPackInfo={editableProductMultiPackInfo}
        pageView={pageView}
        className={className}
        toggleEditAllowance={toggleEditAllowance}
        isEditAllowed={isEditAllowed}
        inheritedStyles={inheritedStyles}
        isPlcc={isPlcc}
        itemIndex={itemIndex}
        openedTile={openedTile}
        setSelectedProductTile={setSelectedProductTile}
        setSwipedElement={setSwipedElement}
        swipedElement={swipedElement}
        isShowSaveForLater={isShowSaveForLater}
        sflMaxCount={sflMaxCount}
        isGenricGuest={isGenricGuest}
        addItemToSflList={addItemToSflList}
        setCartItemsSflError={setCartItemsSflError}
        sflItemsCount={sflItemsCount}
        isBagPageSflSection={isBagPageSflSection}
        startSflItemDelete={startSflItemDelete}
        startSflDataMoveToBag={startSflDataMoveToBag}
        onQuickViewOpenClick={onQuickViewOpenClick}
        isBossEnabledTCP={isBossEnabledTCP}
        isBossEnabledGYM={isBossEnabledGYM}
        isBopisEnabledTCP={isBopisEnabledTCP}
        isBopisEnabledGYM={isBopisEnabledGYM}
        isBossEnabledSNJ={isBossEnabledSNJ}
        isBopisEnabledSNJ={isBopisEnabledSNJ}
        isBossEnabledPJP={isBossEnabledPJP}
        isBopisEnabledPJP={isBopisEnabledPJP}
        isBossClearanceProductEnabled={isBossClearanceProductEnabled}
        isBopisClearanceProductEnabled={isBopisClearanceProductEnabled}
        isRadialInventoryEnabled={isRadialInventoryEnabled}
        onPickUpOpenClick={onPickUpOpenClick}
        orderId={orderId}
        setShipToHome={setShipToHome}
        toggleError={toggleError}
        toggleBossBopisError={toggleBossBopisError}
        clearToggleError={clearToggleError}
        currencyExchange={currencyExchange}
        pickupStoresInCart={pickupStoresInCart}
        autoSwitchPickupItemInCart={autoSwitchPickupItemInCart}
        navigation={navigation}
        updateAppTypeHandler={updateAppTypeHandler}
        disableProductRedirect={disableProductRedirect}
        setClickAnalyticsData={setClickAnalyticsData}
        closeMiniBag={closeMiniBag}
        handleAddToWishlist={this.handleAddToWishlist}
        isLoggedIn={isLoggedIn}
        showLoginModal={showLoginModal}
        toggleLoginModal={this.toggleLoginModal}
        cartOrderItems={cartOrderItems}
        isInternationalShipping={isInternationalShipping}
        cookieToken={cookieToken}
        isMiniBag={isMiniBag}
        isMultipackProduct={isMultipackProduct}
        isBrierleyWorking={isBrierleyWorking}
        isDynamicBadgeEnabled={isDynamicBadgeEnabled}
        spcBag={spcBag}
        breadCrumbs={breadCrumbs}
        newBag={newBag}
        newMiniBag={newMiniBag}
        isLowInventoryBannerEnabledForOldDesign={isLowInventoryBannerEnabledForOldDesign}
        LoyaltyPoints={LoyaltyPoints}
        isOffersDisplayEnabled={isOffersDisplayEnabled}
        isPickupStoreModalRedisgn={isPickupStoreModalRedisgn}
        orderPriceAdjustments={orderPriceAdjustments}
        updateDeliveryMethodIndex={updateDeliveryMethodIndex}
        orderAccessorieItems={orderAccessorieItems}
        isLoyaltyPointsEnabled={isLoyaltyPointsEnabled}
        isBossEnabled={isBossEnabled}
        clearCheckoutServerError={clearCheckoutServerError}
        backpackSFLCallAction={backpackSFLCallAction}
        isCrossBrandMerchandisingEnabled={isCrossBrandMerchandisingEnabled}
        extendedOrderThreshold={extendedOrderThreshold}
        isRemoveItemInProgress={isRemoveItemInProgress}
        isDeleteAnimationEnabled={isDeleteAnimationEnabled}
        isHardPriceMarkdownEnabled={isHardPriceMarkdownEnabled}
        isHardcodeSizeMapEnabled={isHardcodeSizeMapEnabled}
        hardcodeSizeMapConfig={hardcodeSizeMapConfig}
        isDesktopProductTileCleanUpDisabled={isDesktopProductTileCleanUpDisabled}
        orderEddDatesValues={orderEddDatesValues}
        isMobileWebTileEnhancementEnabled={isMobileWebTileEnhancementEnabled}
        showBopisTileBasedOnStoreSpecials={showBopisTileBasedOnStoreSpecials}
      />
    );
  }
}

const createSetShipToHomePayload = (orderItemId, orderItemType, isCartPage) => {
  return {
    apiPayload: {
      orderId: '.',
      orderItem: [
        {
          orderItemId,
        },
      ],
      x_storeLocId: '',
      x_orderitemtype: orderItemType,
      x_updatedItemType: CONSTANTS.ORDER_ITEM_TYPE.ECOM,
    },
    updateActionType: 'UpdatePickUpItem',
    fromToggling: true,
    isCartPage,
  };
};

const createBossBopisTogglePayload = (props, isCartPage) => {
  const { itemId, quantity, skuId, targetOrderType, orderId, store, storeId, isCartTileQtyChange } =
    props;
  const { itemPartNumber, variantNo, orderItemType } = props;
  return {
    apiPayload: {
      orderId: `${orderId}`,
      orderItem: [
        {
          orderItemId: itemId,
          xitem_catEntryId: skuId,
          quantity: `${quantity}`,
          variantNo,
          itemPartNumber,
        },
      ],
      x_storeLocId: storeId,
      x_orderitemtype: !store ? CONSTANTS.ORDER_ITEM_TYPE.ECOM : orderItemType, // source type of Item
      x_updatedItemType: targetOrderType, // target type of Item
    },
    updateActionType: 'UpdatePickUpItem',
    fromTogglingBossBopis: true,
    isCartTileQtyChange,
    isCartPage,
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    getOrderDetails: () => {
      dispatch(BAG_PAGE_ACTIONS.getOrderDetails());
    },
    removeCartItem: (orderItemId) => {
      dispatch(removeCartItem(orderItemId));
    },
    updateCartItem: (
      itemId,
      skuId,
      quantity,
      itemPartNumber,
      variantNo,
      isMiniBagOpen,
      ...args
    ) => {
      const [
        multipackProduct,
        multiPackCount,
        size,
        getAllNewMultiPack,
        getAllMultiPack,
        skuInfo,
        partIdInfo,
        isCartTileQtyChange,
        isCartPage,
        multiPackItems,
        TCPProductIndStore,
        isHardMarkPrice,
      ] = args;
      dispatch(
        updateCartItem({
          itemId,
          skuId,
          quantity,
          itemPartNumber,
          variantNo,
          isMiniBagOpen,
          multipackProduct,
          multiPackCount,
          size,
          getAllNewMultiPack,
          getAllMultiPack,
          skuInfo,
          partIdInfo,
          isCartTileQtyChange,
          multiPackItems,
          isCartPage,
          TCPProductIndStore,
          isHardMarkPrice,
        })
      );
    },
    getProductSKUInfo: (payload) => {
      dispatch(getProductSKUInfo(payload));
    },
    addItemToSflList: (payload, price) => {
      dispatch(BAG_PAGE_ACTIONS.addItemToSflList(payload, price));
    },
    setCartItemsSflError: (payload) => {
      dispatch(BAG_PAGE_ACTIONS.setCartItemsSflError(payload));
    },
    startSflItemDelete: (payload) => {
      dispatch(BAG_PAGE_ACTIONS.startSflItemDelete(payload));
    },
    startSflDataMoveToBag: (payload) => {
      dispatch(BAG_PAGE_ACTIONS.startSflDataMoveToBag(payload));
    },
    onQuickViewOpenClick: (payload) => {
      dispatch(openQuickViewWithValues(payload));
    },
    onPickUpOpenClick: (payload) => {
      dispatch(openPickupModalWithValuesFromBag(payload));
    },
    setShipToHome: (orderItemId, orderItemType, isCartPage) => {
      dispatch(updateCartItem(createSetShipToHomePayload(orderItemId, orderItemType, isCartPage)));
    },
    autoSwitchPickupItemInCart: (payload, isCartPage) => {
      dispatch(updateCartItem(createBossBopisTogglePayload(payload, isCartPage)));
    },
    clearToggleError: () => {
      dispatch(clearToggleCartItemError());
      dispatch(clearToggleBossBopisCartItemError());
    },
    updateAppTypeHandler: (payload) => {
      dispatch(updateAppTypeWithParams(payload));
    },
    setClickAnalyticsData: (payload) => {
      dispatch(setClickAnalyticsData(payload));
    },
    onAddItemToFavorites: (payload) => {
      dispatch(addItemsToWishlist(payload));
    },
    updateDeliveryMethodIndex: (payload) => {
      const payloadObj = {
        isFromCart: true,
        deliveryMethodIndex: payload,
      };
      dispatch(updateDeliveryMethodSelection(payloadObj));
    },
    setBackPackAloneErrorRedux: (payload) => {
      dispatch(setBackPackAloneError(payload));
    },
    setBackPackOOSErrorRedux: (payload) => {
      dispatch(setBackPackOOSError(payload));
    },
    clearCheckoutServerError: (data) => dispatch(CHECKOUT_ACTIONS.setServerErrorCheckout(data)),
    setBackPackDeletedErrorAction: (payload) => {
      dispatch(BAG_PAGE_ACTIONS.setBackPackDeletedError(payload));
    },
    backpackSFLCallAction: (payload) => {
      dispatch(backpackSFLCall(payload));
    },
    moveItemsToBossUnavailableListAction: (payload) => {
      dispatch(moveItemsToBossUnavailableList(payload));
    },
    saveProductDataForPdp: (payload) => {
      dispatch(setCartProductData(payload));
    },
    fetchCouponTermsAndConditions: (coupon) => {
      dispatch(getCouponTermsAndConditions(coupon));
    },
    setOpenCouponDetailModal: (payload) => dispatch(setOpenCouponDetailModalActn(payload)),
  };
};

export function mapStateToProps(state) {
  return {
    editableProductInfo: getEditableProductInfo(state),
    editableProductMultiPackInfo: getEditableProductMultiPackInfo(state),
    isShowSaveForLater: getSaveForLaterSwitch(state),
    sflMaxCount: parseInt(getSflMaxCount(state), 10),
    isGenricGuest: getPersonalDataState(state),
    isBossEnabledTCP: getIsBossEnabled(state, CARTPAGE_CONSTANTS.BRANDS.TCP),
    isBossEnabledGYM: getIsBossEnabled(state, CARTPAGE_CONSTANTS.BRANDS.GYM),
    isBopisEnabledTCP: getIsBopisEnabled(state, CARTPAGE_CONSTANTS.BRANDS.TCP),
    isBopisEnabledGYM: getIsBopisEnabled(state, CARTPAGE_CONSTANTS.BRANDS.GYM),
    isBossEnabledSNJ: getIsBossEnabled(state, CARTPAGE_CONSTANTS.BRANDS.SNJ),
    isBopisEnabledSNJ: getIsBopisEnabled(state, CARTPAGE_CONSTANTS.BRANDS.SNJ),
    isBossEnabledPJP: getIsBossEnabled(state, CARTPAGE_CONSTANTS.BRANDS.PJP),
    isBopisEnabledPJP: getIsBopisEnabled(state, CARTPAGE_CONSTANTS.BRANDS.PJP),
    isBopisEnabled: getIsBopisEnabled(state),
    isBossEnabled: getIsBossEnabled(state),
    isBossClearanceProductEnabled: getIsBossClearanceProductEnabled(state),
    isBopisClearanceProductEnabled: getIsBopisClearanceProductEnabled(state),
    isRadialInventoryEnabled: getIsRadialInventoryEnabled(state),
    orderId: BAGPAGE_SELECTORS.getCurrentOrderId(state) || '',
    toggleError: getCartToggleError(state),
    toggleBossBopisError: getCartBossBopisToggleError(state),
    pickupStoresInCart: BAGPAGE_SELECTORS.getCartStores(state),
    isMiniBagOpen: getIsMiniBagOpen(state),
    isLoggedIn: getUserLoggedInState(state),
    cartOrderItems: BAGPAGE_SELECTORS.getOrderItems(state),
    isInternationalShipping: getIsInternationalShipping(state),
    cookieToken: NavigateXHRSelector.getCookieToken(state),
    isBrierleyWorking: isBrierleyWorking(state),
    isDynamicBadgeEnabled: getIsDynamicBadgeEnabled(state),
    isCartLoading: getCartLoadingState(state),
    isTileLoading: getTileLoadingState(state),
    bossState: getBossState(state),
    bossCity: getBossCity(state),
    bopisState: getBopisState(state),
    bopisCity: getBopisCity(state),
    isHideMeatBallAbTest: getIsHideMeatBallMenuAbTest(state),
    isShowEditCTAAbTest: getIsShowEditCTAAbTest(state),
    isPickupStoreModalRedisgn: getPickupStoreModalRedsign(state),
    isOffersDisplayEnabled: getIsOffersDisplayEnabled(state),
    shipments: getOrderShipments(state),
    isBossCart: getBossStatus(state),
    orderPriceAdjustments: BAGPAGE_SELECTORS.getOrderPriceAdjustments(state),
    isAppSFLEnabled: getIsSFLEnabledApp(state),
    isLoyaltyPointsEnabled: getIsPersistPointsApiEnabled(state),
    buttonLoading: BAGPAGE_SELECTORS.buttonLoaderState(state),
    isVMPBOSSEnabled: getIsVMPBossEnabled(state),
    sflBackPackCall: getSflBackPackCall(state),
    isCrossBrandMerchandisingEnabled: getIsCrossBrandMerchandisingEnabled(state),
    isCartItemsUpdating: getIsCartItemsUpdating(state),
    extendedOrderThreshold: getExtendedPreOrderValue(state),
    isRemoveItemInProgress: getRemoveItemInProgress(state),
    isHardPriceMarkdownEnabled: getIsHideOriginalPriceAndMarchantTagEnabled(state),
    isHardcodeSizeMapEnabled: getIsHardcodeSizeMapEnabled(state),
    hardcodeSizeMapConfig: getHardcodeSizeMapConfig(state),
    bossUnavailableSwitch: getBossUnavailableSwitch(state),
    socialProofCartData: getSocialProofCartMessage(state),
    isNonEligibleForCouponsEnabled: getNonEligibleForCouponsEnabled(state),
    isSocialProofViaEngineApiEnabledApp: getIsSocialProofViaEngineApiEnabled(state),
    isSiteBusterAbTestEnabled: getIsSiteBusterAbTestEnabled(state),
    promoKey: getPromoKeyConfig(state),
    isDesktopProductTileCleanUpDisabled: getDesktopProductTileCleanUpDisabled(state),
    orderEddDatesValues: getOrderEddDates(state),
    displayAvailableOffersAbTest: getDisplayAvailableOffersAbTest(state),
    isBopisPromoDiscountBannerEnabled: getIsBopisPromotionDiscountEnabled(state),
    defaultBopisPromotionDiscountValue: getDefaultBopisPromotionDiscountValue(state),
    offerTypeBasedPromotion: getOfferTypeBasedPromotion(state),
    allPromotionsData: getPromotionsData(state),
    storeHoursThreshold: getStoreHoursThreshold(state),
    isDisplayPickupTimeEnabled: getIsDisplayPickupTimeEnabled(state),
    isFullDateDisplayEnabled: getIsFullDateDisplayEnabled(state),
    userStore: getDefaultStoreData(state),
    isShowDeleteIconInBag: getIsShowDeleteIconInBag(state),
    isMobileWebTileEnhancementEnabled: getMobileWebProductTileEnhancement(state),
    showBopisTileBasedOnStoreSpecials: getShowBopisTileBasedOnStoreSpecials(state),
    isAppendUPCInPDPURLEnabled: getIsAppendUPCInPDPURLEnabled(state),
    lastAppliedCoupon: getLastAppliedCoupon(state),
    lastAppliedCouponData: getLastAppliedCouponData(state),
    isRestrictedShippingStatesEnabled: getRestrictedShippingStatesEnabled(state),
    stateNameMap: getStateNameMap(state),
    breadCrumbs: getBreadCrumbs(state),
    currencyExchange: getCurrencyAttributesAsArray(state),
    isItemLevelOnHoldMsgEnabled: getIsItemLevelOnHoldMsgEnabled(state),
    isBrandExclusionMessageEnabled: getIsBrandExclusionMessageEnabled(state),
  };
}

CartItemTileContainer.propTypes = {
  productDetail: PropTypes.shape({}).isRequired,
  getProductSKUInfo: PropTypes.func.isRequired,
  updateCartItem: PropTypes.func.isRequired,
  editableProductInfo: PropTypes.shape({}).isRequired,
  editableProductMultiPackInfo: PropTypes.shape({}),
  removeCartItem: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired,
  isPlcc: PropTypes.string.isRequired,
  pageView: PropTypes.string,
  toggleEditAllowance: PropTypes.func.isRequired,
  isEditAllowed: PropTypes.bool,
  isShowSaveForLater: PropTypes.bool.isRequired,
  isGenricGuest: PropTypes.shape({}).isRequired,
  sflItemsCount: PropTypes.number,
  sflMaxCount: PropTypes.number.isRequired,
  addItemToSflList: PropTypes.func.isRequired,
  setCartItemsSflError: PropTypes.func.isRequired,
  isBagPageSflSection: PropTypes.bool,
  startSflItemDelete: PropTypes.func.isRequired,
  startSflDataMoveToBag: PropTypes.func.isRequired,
  onPickUpOpenClick: PropTypes.func.isRequired,
  orderId: PropTypes.number.isRequired,
  setShipToHome: PropTypes.func.isRequired,
  toggleError: PropTypes.shape({}),
  toggleBossBopisError: PropTypes.shape({
    errorMessage: PropTypes.string,
  }),
  clearToggleError: PropTypes.func.isRequired,
  currencyExchange: PropTypes.shape([]),
  pickupStoresInCart: PropTypes.shape({}).isRequired,
  autoSwitchPickupItemInCart: PropTypes.func.isRequired,
  disableProductRedirect: PropTypes.bool,
  setClickAnalyticsData: PropTypes.func.isRequired,
  closeMiniBag: PropTypes.func,
  inheritedStyles: PropTypes.string,
  itemIndex: PropTypes.number,
  openedTile: PropTypes.number,
  setSelectedProductTile: PropTypes.func.isRequired,
  swipedElement: PropTypes.shape({}).isRequired,
  updateAppTypeHandler: PropTypes.func.isRequired,
  onQuickViewOpenClick: PropTypes.func.isRequired,
  navigation: PropTypes.shape({}),
  setSwipedElement: PropTypes.func,
  isBopisClearanceProductEnabled: PropTypes.bool.isRequired,
  isBossClearanceProductEnabled: PropTypes.bool.isRequired,
  isBossEnabledTCP: PropTypes.bool.isRequired,
  isBossEnabledGYM: PropTypes.bool.isRequired,
  isBopisEnabledTCP: PropTypes.bool.isRequired,
  isBopisEnabledGYM: PropTypes.bool.isRequired,
  isBossEnabledPJP: PropTypes.bool.isRequired,
  isBopisEnabledPJP: PropTypes.bool.isRequired,
  isRadialInventoryEnabled: PropTypes.bool.isRequired,
  isMiniBagOpen: PropTypes.bool.isRequired,
  onAddItemToFavorites: PropTypes.func.isRequired,
  isInternationalShipping: PropTypes.bool.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  isBrierleyWorking: PropTypes.bool,
  cartOrderItems: PropTypes.shape([]).isRequired,
  isMultipackProduct: PropTypes.bool,
  cookieToken: PropTypes.string,
  isMiniBag: PropTypes.bool,
  isDynamicBadgeEnabled: PropTypes.shape({}),
  spcBag: PropTypes.bool,
  breadCrumbs: PropTypes.shape([]),
  newBag: PropTypes.bool,
  isLowInventoryBannerEnabled: PropTypes.bool,
  isLowInventoryBannerEnabledForOldDesign: PropTypes.bool,
  bossState: PropTypes.string,
  bossCity: PropTypes.string,
  bopisState: PropTypes.string,
  bopisCity: PropTypes.string,
  isPickupStoreModalRedisgn: PropTypes.bool,
  showToggleLinkProductTile: PropTypes.bool,
  pickUpTileEnabled: PropTypes.bool,
  isBossCart: PropTypes.bool,
  isNonBossCart: PropTypes.bool,
  orderPriceAdjustments: PropTypes.shape([]),
  sflItems: PropTypes.shape([]),
  isLoyaltyPointsEnabled: PropTypes.bool,
  setBackPackAloneErrorRedux: PropTypes.func,
  setBackPackOOSErrorRedux: PropTypes.func,
  setBackPackDeletedErrorAction: PropTypes.func,
  buttonLoading: PropTypes.bool,
  isCartItemsUpdating: PropTypes.shape({}),
  isDeleteAnimationEnabled: PropTypes.bool.isRequired,
  extendedOrderThreshold: PropTypes.number,
  isAppendUPCInPDPURLEnabled: PropTypes.bool,
};

CartItemTileContainer.defaultProps = {
  inheritedStyles: '',
  itemIndex: 0,
  openedTile: 0,
  setSwipedElement: () => {},
  closeMiniBag: () => {},
  navigation: {},
  pageView: '',
  isEditAllowed: true,
  sflItemsCount: 0,
  isBagPageSflSection: false,
  toggleError: null,
  toggleBossBopisError: null,
  currencyExchange: null,
  disableProductRedirect: false,
  isBrierleyWorking: true,
  cookieToken: null,
  isMiniBag: false,
  isMultipackProduct: false,
  editableProductMultiPackInfo: {},
  isDynamicBadgeEnabled: false,
  spcBag: false,
  breadCrumbs: null,
  newBag: false,
  isLowInventoryBannerEnabled: false,
  isLowInventoryBannerEnabledForOldDesign: false,
  bossState: '',
  bossCity: '',
  bopisState: '',
  bopisCity: '',
  isPickupStoreModalRedisgn: false,
  showToggleLinkProductTile: false,
  pickUpTileEnabled: false,
  isBossCart: false,
  isNonBossCart: false,
  orderPriceAdjustments: [],
  sflItems: [],
  isLoyaltyPointsEnabled: false,
  setBackPackAloneErrorRedux: () => {},
  setBackPackOOSErrorRedux: () => {},
  setBackPackDeletedErrorAction: () => {},
  buttonLoading: false,
  isCartItemsUpdating: {},
  extendedOrderThreshold: 0,
  isAppendUPCInPDPURLEnabled: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(CartItemTileContainer);
